package com.shadowings.gero.data.lessons.chapter6

import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TrueFalseContent
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.*

fun getSdmFIntroContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_intro,
            content = Res.string.exp_content_sdm_f_zeta_1,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_intro,
            content = Res.string.exp_content_sdm_f_alyn_react,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_intro,
            content = Res.string.exp_content_sdm_f_nilo_react,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_intro,
            content = Res.string.exp_content_sdm_f_zeta_2,
            face = Faces.Idle,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_intro,
            content = Res.string.exp_content_sdm_f_use_present,
            face = Faces.Idle,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_intro,
            content = Res.string.exp_content_sdm_f_use_future,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_intro,
            content = Res.string.exp_content_sdm_f_use_subjunctive,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_intro,
            content = Res.string.exp_content_sdm_f_use_habitual,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_sdm_f_intro,
            content = Res.string.exp_content_sdm_f_zeta_3,
            face = Faces.Happy,
            character = Characters.Zeta,
        )
    )
}

fun getSdmFIntroQuizContent(): List<IQuizContent> {
    return listOf(
        TrueFalseContent(
            text = Res.string.quiz_sdm_f_intro_1,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_sdm_f_intro_2,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_sdm_f_intro_3,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_sdm_f_intro_4,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_sdm_f_intro_5,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_sdm_f_intro_6,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_sdm_f_intro_7,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_sdm_f_intro_8,
            correct = false
        )
    )
}
